import React, { useEffect } from "react";
import Topbar from "../components/Topbar";
import Bottombar from "../components/Bottombar";
import MidSection from "../components/MidSection";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { getConfigurationData, getImage } from "../utils/api";
import * as CryptoJS from "crypto-js";
import { useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import {
  updateConfigurationData,
  updateLogo,
} from "../Redux/Reducers/dynamicStoreSlice";
function Home() {
  const params = useParams();
  const dispatch = useDispatch();

  useEffect(() => {
    const generateApiKey = ({ tenant_id }) => {
      const payload = {
        tenant_id: tenant_id,
        tenant: [
          {
            value: tenant_id,
          },
        ],
        exp: Math.floor(Date.now() / 1000) + 30 * 60, // Expires in 30 minutes
      };
      const secretKey = process.env.REACT_APP_JWT_KEY;
      const stringifiedPayload = JSON.stringify(payload);
      const ciphertext = CryptoJS.AES.encrypt(
        stringifiedPayload,
        secretKey
      ).toString();
      sessionStorage.setItem("app_name", ciphertext);
      sessionStorage.setItem("tenant_name", tenant_id);
      console.log("ciphertext", ciphertext);
    };
    // generateApiKey({ tenant_id: params?.id });
    sessionStorage.setItem("app_name", params?.id);
  }, [params?.id]);

  useEffect(() => {
    async function fetchData() {
      const configData = await getConfigurationData();
      console.log("confidData", configData);
      if (Object?.keys(configData?.result)?.length > 0) {
        if (configData?.result?.logo_img) {
          const img_url = await getImage(configData?.result?.logo_img);
          console.log("img_url", img_url);
          dispatch(updateLogo(img_url));
        }
        dispatch(updateConfigurationData(configData?.result));
      }
    }
    fetchData();
  }, []);

  return (
    <div className="w-100 h-100">
      <ToastContainer />
      <Topbar />
      <MidSection />
      <Bottombar />
    </div>
  );
}

export default Home;
